import React, { useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import CardItem from "./CardItem";

const LearnerDashboard = () => {
  const [cards, setCards] = useState([
    { id: 1, title: "Core & Obj Prog", labName: "LabName1", mentorName: "Mentor1", isActive: true },
    { id: 2, title: "Core & Obj Prog", labName: "LabName2", mentorName: "Mentor2", isActive: false },
    { id: 3, title: "Core & Obj Prog", labName: "LabName3", mentorName: "Mentor3", isActive: true },
    { id: 4, title: "Core & Obj Prog", labName: "LabName4", mentorName: "Mentor4", isActive: false },
  ]);

  const toggleCardState = (id) => {
    setCards((prevCards) =>
      prevCards.map((card) =>
        card.id === id ? { ...card, isActive: !card.isActive } : card
      )
    );
  };

  return (
    <Box width="100%">
      <Typography variant="h4" gutterBottom  sx={{
            fontSize: { xs: "20px", sm: "16px", md: "18px", lg: "30px" },
            mb:3,
            fontWeight: "bold",
            color: "primary.main",
          }}>
        Welcome Shubham!
      </Typography>
      <Grid container  spacing={3}>
        {cards.map((card) => (
          <Grid
            item
            key={card.id}
            xs={11} // Full width on extra-small screens
            sm={6}  // 2 cards per row on small screens
            md={4}  // 3 cards per row on medium screens
            lg={4}  // 4 cards per row on large screens
          >
            <CardItem
              title={card.title}
              labName={card.labName}
              mentorName={card.mentorName}
              isActive={card.isActive}
              onClick={() => toggleCardState(card.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LearnerDashboard;
